<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-8"></div>
      <div class="col-sm-4">
        <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit">
          <b-card id="login-card"
            :img-src="require('../assets/login-logo.svg')">
            <b-card-body>
              <div class="form-group">
                <label for="account" class="lab-color">帳號</label>
                <validate>
                  <input
                    name="Input_account"
                    v-model="account"
                    type="text"
                    id="account"
                    class="form-control"
                    placeholder="請輸入帳號" required autofocus />
                  <field-messages name="Input_account" show="$invalid && $submitted" class="lab-warn-color">
                    <div slot="required">請輸入帳號</div>
                  </field-messages>
                </validate>
              </div>
              <div class="form-group">
                <label for="pwd" class="lab-color">密碼</label>
                <validate>
                  <input
                    v-model="password"
                    name="Input_pwd"
                    type="password"
                    id="pwd"
                    class="form-control"
                    placeholder="請輸入密碼" required />
                  <field-messages name="Input_pwd" show="$invalid && $submitted" class="lab-warn-color">
                    <div slot="required">請輸入密碼</div>
                  </field-messages>
                </validate>
              </div>
              <b-button-group>
                <button
                  type="submit"
                  v-if="loading==false"
                  class="btn"
                  id="login-btn">
                  登入
                </button>
              </b-button-group>
              <b-progress id="login-progress-bar" v-if="loading" :value="100" :max="100" animated></b-progress>
            </b-card-body>
          </b-card>
        </vue-form>
      </div>
    </div>
    <div id="login-bg" class="logo-img-message">MWD，溫暖每一天
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import miniToastr from 'mini-toastr'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { mapGetters } from 'vuex'
// document.body.style.backgroundAttachment = 'fixed'
// document.getElementById('login-bg').style.backgroundImage = 'url(' + require('../assets/login-bg.jpg') + ')'
// document.body.style.backgroundPosition = 'center center'
// document.body.style.backgroundRepeat = 'no-repeat'

Vue.use(BootstrapVue)
miniToastr.init()

export default {
  data () {
    return {
      account: '',
      password: '',
      formstate: {}
    }
  },
  computed: mapGetters({
    // 取得 loading state
    loading: 'getLoading'
  }),
  methods: {
    // 因為 action 包裝了 Promise 所以可以使用 then 和 catch 來接收非同步回傳狀態
    onSubmit () {
      // console.log('AA')
      if (this.formstate.$invalid) {
      } else {
        this.$store.dispatch('actionLogin', {
          account: this.account,
          password: this.password
        })
          .then((response) => {
            if (response.data.result === '0000') {
              this.$store.commit('COMPANY', response.data.companyId)
              this.$store.commit('TOKEN', response.data.jwt)
              this.$store.commit('LoginUserName', response.data.userName)
              this.$store.commit('LoginUserID', Number(response.data.userID))
              this.$store.commit('FUNCTION', response.data.data)
              this.$store.commit('LOADING', false)
              this.$router.push('/home')
            } else {
              if (response.data.result === '0014') {
                miniToastr.error('帳號/密碼輸入錯誤!請重新輸入')
              } else if (response.data.result === '1111') {
                miniToastr.error('此帳號已被停權，請聯絡系統管理員')
              } else {
                miniToastr.error(response.data.message)
              }
              this.$store.commit('LOADING', false)
            }
          })
          .catch((error) => {
            miniToastr.error(error, 'Error')
            this.$store.commit('LOADING', false)
          })
      }
    }
  },
  created () {
    // 在 vue 調用 router
    console.log('vue created:', this.$route.matched[0])
    this.$store.dispatch('actionLogout')
  }
}
</script>

<style scoped>
.container {
  margin-top: 60px;
}

.lab-color {
  color: #fff;
}

.lab-warn-color {
  color: #F35050;
}

.card-img {
  width: 58%;
  /* mheight: 45px; */
  /* margin:auto; */
  margin: 31px auto 10px auto;
  object-fit: contain;
}
.logo-img-message {
  color: white;
  font-size: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-shadow: 0.1em 0.1em 0.2em black;
}

#login-bg {
  background-image: url('../assets/login-bg.png');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  height:100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -10;
}

#login-btn {
  color: #fff;
  background-color: #004f2d;
  border-color: #519b39;
}

#login-btn:hover {
  background-color: #519b39;
}

#login-btn:focus, #account:focus, #pwd:focus {
  box-shadow: 0 0 0 0.2rem #519b39;
}

#login-card {
  background-color: #004f2d;
}

#login-progress-bar {
  background-color: #519b39!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue